import React, { useState, useEffect } from 'react';
import { Button, Grid } from '@material-ui/core';
import { useHistory, useLocation } from 'react-router-dom';
import Cookies from 'universal-cookie';
import Page from '../../layout/components/PageAuth.jsx';
import SocialAuthSetPhoneForm from './forms/SocialAuthSetPhoneForm';
import LogoColor from '../../assets/images/logo-master-color.png';
import demoImage from '../../assets/images/demoimage_new.png';

import Footer from '../../layout/components/FooterAuth';
import RightContent from './common/ContentRightSignup';
import { Slide } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { _route } from '../../utils/sg.js';
import PopupModal from '../../components/common/PopupModal.jsx';
import { addScript } from '../../utils/addScript.js';

function SetPhoneAfterSocialAuth() {
  const history = useHistory();
  const routeParams = useLocation().search;
  const [setupFinish, setSetupFinish] = useState(false);
  const [scheduleDemo, setScheduleDemo] = useState(false);

  const searchParamsData = new URLSearchParams(routeParams);
  const routeParamsValue = searchParamsData.get('autopilot');
  if (routeParamsValue === 'true') {
    const cookies = new Cookies();
    cookies.set('autopilot', 'true', { path: '/' });
  }

  useEffect(() => {
    if (scheduleDemo) {
      addScript([
        {
          key: 'src',
          value: 'https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js',
        },
      ]);
    }
  }, [scheduleDemo]);

  return (
    <Page title="Finish Sign up">
      <Grid container className="auth_view">
        <Grid item lg={6} md={12} sm={12} xs={12} className="auth_view_content customScrollbar">
          <div className="signup_holder">
            <div className="web_show">
              <a className="logo_reg" href="/">
                <img src={LogoColor} alt="Logo" className="logo_auth" />
              </a>
            </div>
          </div>
          <div className="mob_show">
            <div>
              <a className="logo_reg" href="/">
                <img src={LogoColor} alt="Logo" className="logo_auth" />
              </a>
            </div>
          </div>
          <div className="form_main_content">
            <Slide direction="up" in={setupFinish} mountOnEnter unmountOnExit>
              <div className="signup_form_holder">
                <div className="title_reg_right">Thanks for Signing up to SellerGeni!</div>
                <p className="subtitle_reg_right web_show">You can access the tool right away...</p>
                <div style={{ display: 'flex' }}>
                  <Button
                    className="aisleSecondarysubmitButton"
                    style={{ backgroundColor: '#000' }}
                    endIcon={<ArrowForwardIcon />}
                    onClick={() => history.push(_route('growz.overview'))}
                  >
                    Access SellerGeni
                  </Button>
                </div>
                <div className="diveder_line_auth">
                  <span className="diveder_line_auth_text">OR</span>
                </div>
                <div>
                  <img src={demoImage} width="100%" />
                </div>
                <p className="subtitle_reg_right web_show" style={{ fontSize: '16px', fontWeight: 500, marginTop: '12px' }}>
                  Get a Free demo session with our in-house Amazon strategist on scheduling a demo call below.
                </p>
                <div style={{ display: 'flex' }}>
                  <Button className="rippleEffect" onClick={() => setScheduleDemo(true)}>
                    Schedule a Demo
                  </Button>
                </div>
              </div>
            </Slide>
            {!setupFinish && (
              <div className="signup_form_holder">
                <div className="title_reg_right">
                  Welcome to SellerGeni, <br /> Setup your account
                </div>
                <p className="subtitle_reg_right web_show">This will help us tailor your experience.</p>

                <SocialAuthSetPhoneForm handleSetupFinish={(val) => setSetupFinish(val)} />
              </div>
            )}
          </div>
          <Footer />
        </Grid>
        <RightContent />
      </Grid>
      <PopupModal
        openModal={scheduleDemo}
        handleModalClose={() => setScheduleDemo(false)}
        heading="Schedule Product Demo"
        width="74%"
        height="94%"
        Customheight="94%"
      >
        <div class="meetings-iframe-container" data-src="https://meetings-eu1.hubspot.com/athmajith?embed=true"></div>
      </PopupModal>
    </Page>
  );
}

export default SetPhoneAfterSocialAuth;
